import { render } from "./SearchableExpandableCheckbox.vue?vue&type=template&id=730b71a8"
import script from "./SearchableExpandableCheckbox.vue?vue&type=script&lang=js"
export * from "./SearchableExpandableCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script